import { Anchor, Breadcrumbs, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import BannersDetailsForm from '../../../components/Banners/BannersDetailsForm';
import ErrorMessage from '../../../components/ErrorMessage';
import Metadata from '../../../components/Metadata';
import Spinner from '../../../components/Spinner';
import { Page } from '../../../constants/pageTitles';
import useFetch from '../../../helpers/useFetch';

const BannersDetailsPage = ({ type = 'banners' }) => {
  const page = `${Page[type]}`;
  const location = useLocation();
  const navigate = useNavigate();
  const fetch = useFetch();

  const [segments, setSegments] = useState();
  const [loadError, setLoadError] = useState();
  const [banner, setBanner] = useState();
  const { accountId, domainId, id } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/segments?scope=internal`)
      .then(({ segments }) => {
        setSegments(segments);
      })
      .catch(setLoadError);
  }, [fetch, accountId, domainId]);

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/banners/${id}`)
      .then(({ banner }) => {
        if (!banner) {
          navigate(`/accounts/${accountId}/domains/${domainId}/banners`);
        }

        setBanner(banner);
      })
      .catch(setLoadError);
  }, [fetch, navigate, accountId, domainId, id]);

  const goBack = () => {
    navigate(`/accounts/${accountId}/domains/${domainId}/banners`);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (banner === undefined || segments === undefined) {
    return <Spinner />;
  }

  const del = (cb) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/banners/${banner.id}`, {
      method: 'DELETE',
    })
      .then(() => {
        if (typeof cb === 'function') {
          cb();
        }
        goBack();
      })
      .catch(setLoadError);
  };

  return (
    <>
      <Metadata title={`${page} | ${banner.name} | Edit`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/banners`}>Banners</Anchor>
        <Anchor href={`#${location.pathname.replace('details', 'analytics')}`}>{banner.name}</Anchor>
        <Text>Edit</Text>
      </Breadcrumbs>
      <BannersDetailsForm
        banner={banner}
        onSuccess={goBack}
        onBack={goBack}
        onCopy={() => navigate(`/accounts/${accountId}/domains/${domainId}/banners/new?from=${id}`)}
        del={del}
      />
    </>
  );
};

export default BannersDetailsPage;
